import { MarketplaceTabGroup } from '../../../../../utils/tabGroupDividers';

export enum BuyerOppMarketplaceTab {
    EngagementHistory = 1,
    Documents = 2,
    Timeline = 3,
    DeadlineDocket = 4,
    SellerProfile = 5,
    DealTeam = 6,
    CommsHub = 7,
    ProcessCommercialTerms = 8,
    LoiSubmissionPackage = 9,
    FlowOfFunds = 10,
    DataRoom = 11,
    LegalTermsSummary = 12,
}

export const BuyerOppMarketplaceTabs = [
    {
        id: BuyerOppMarketplaceTab.EngagementHistory,
        content: 'Engagement History',
        group: MarketplaceTabGroup.Engagement,
    },
    {
        id: BuyerOppMarketplaceTab.Documents,
        content: 'Engagement Documents',
        group: MarketplaceTabGroup.DealWorkspace,
    },
    {
        id: BuyerOppMarketplaceTab.Timeline,
        content: 'Timeline',
        group: MarketplaceTabGroup.DealWorkspace,
    },
    {
        id: BuyerOppMarketplaceTab.DeadlineDocket,
        content: 'Deadline Docket',
        group: MarketplaceTabGroup.DealWorkspace,
    },
    {
        id: BuyerOppMarketplaceTab.SellerProfile,
        content: 'Seller Profile',
        group: MarketplaceTabGroup.DealWorkspace,
    },
    {
        id: BuyerOppMarketplaceTab.DealTeam,
        content: 'Deal Team',
        group: MarketplaceTabGroup.DealWorkspace,
    },
    {
        id: BuyerOppMarketplaceTab.CommsHub,
        content: 'Comms Hub',
        group: MarketplaceTabGroup.DealWorkspace,
    },
    {
        id: BuyerOppMarketplaceTab.ProcessCommercialTerms,
        content: 'Buyer Fee Schedule',
        group: MarketplaceTabGroup.DealWorkspace,
    },
    {
        id: BuyerOppMarketplaceTab.LoiSubmissionPackage,
        content: 'LOI Submission Package',
        group: MarketplaceTabGroup.DealWorkspace,
    },
    {
        id: BuyerOppMarketplaceTab.FlowOfFunds,
        content: 'Flow of Funds',
        group: MarketplaceTabGroup.DealWorkspace,
    },
    {
        id: BuyerOppMarketplaceTab.DataRoom,
        content: 'Data Room',
        group: MarketplaceTabGroup.ClosingAndBeyond,
    },
    {
        id: BuyerOppMarketplaceTab.LegalTermsSummary,
        content: 'Legal Terms Summary',
        group: MarketplaceTabGroup.ClosingAndBeyond,
    },
];

export const BuyerOppMarketplaceDefaultTabPreference = [
    BuyerOppMarketplaceTab.Timeline,
    BuyerOppMarketplaceTab.DeadlineDocket,
    BuyerOppMarketplaceTab.Documents,
    BuyerOppMarketplaceTab.CommsHub,
    BuyerOppMarketplaceTab.EngagementHistory,
    BuyerOppMarketplaceTab.DealTeam,
    BuyerOppMarketplaceTab.DataRoom,
    BuyerOppMarketplaceTab.SellerProfile,
    BuyerOppMarketplaceTab.ProcessCommercialTerms,
    BuyerOppMarketplaceTab.LoiSubmissionPackage,
    BuyerOppMarketplaceTab.FlowOfFunds,
];
